// src/components/HomePage.jsx
import React from "react";
import "./home.css";
import caitlinImage from "../../assets/Croci.jpeg";
import sarahImage from "../../assets/Leaning.jpg";

export default function OurTeam({ onViewSelect }) {
  return (
    <div className="home-container">
      <div className="home-card">

        {/* Top nav bar */}
        <div className="top-nav">
          <div className="nav-left">
            <button className="nav-tab" onClick={() => onViewSelect('home')}>About Us</button>
            <button className="nav-tab active">Our Team</button>
          </div>
        </div>

        <h3 className="login-title">Meet the Team.</h3>
        
        {/* Team */}
        <div className="team-grid">
          {/* Team Member 1 */}
          <div className="team-member">
            <div className="team-avatar"></div>
            <h4 className="team-name">Amy</h4>
            <p className="team-role">Founder</p>
          </div>

          {/* Team Member 2 */}
          <div className="team-member">
            <div
              className="team-avatar"
              style={{
                backgroundImage: `url(${caitlinImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
              }}
            ></div>
            <h4 className="team-name">Caitlin</h4>
            <p className="team-role">Developer</p>
          </div>

          {/* Team Member 3 */}
          <div className="team-member">
            <div className="team-avatar"></div>
            <h4 className="team-name">Sara</h4>
            <p className="team-role">Developer</p>
          </div>

          {/* Team Member 4 */}
          <div className="team-member">
            <div
              className="team-avatar"
              style={{
                backgroundImage: `url(${sarahImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
              }}
            ></div>
            <h4 className="team-name">Sarah</h4>
            <p className="team-role">Developer</p>
          </div>

          {/* Team Member 5 */}
          <div className="team-member">
            <div className="team-avatar"></div>
            <h4 className="team-name">Grace</h4>
            <p className="team-role">Developer</p>
          </div>
        </div>

      </div>
    </div>
  );
}